import React from 'react';
import styled from 'styled-components';

type Props = {
    children: string,
}

const H1 = (props: Props) => {
    return (
        <H1WithStyled { ...props }>
            { props.children }
        </H1WithStyled>
    );
};

const H1WithStyled = styled.h1`
    margin: 0 0 15px;
    padding: 2px 10px;
    font-size: 26px;
    font-weight: bold;
`

export default H1;